
import React from 'react';

const About: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Intro */}
      <section className="py-32 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400 mb-8">Executive Summary</div>
            <h1 className="text-5xl md:text-7xl font-black text-slate-900 mb-12 tracking-tighter">The Global Mandate:<br/><span className="text-slate-400">Accountability Without Borders</span></h1>
            <p className="text-2xl text-slate-700 leading-relaxed mb-10 font-medium">
              The health of our global democracy depends upon the unwavering alignment between institutional mandates and the public interest; when bureaucratic drift occurs, forensic transparency becomes the essential tool for restoration.
            </p>
            <p className="text-lg text-slate-500 leading-relaxed max-w-3xl">
              We identify the gap between institutional claims and operational reality, uncovering truths obscured by bureaucratic inertia. System Audit operates as a sentinel for the public interest in an age of automated governance and institutional drift.
            </p>
          </div>
        </div>
      </section>

      {/* The Transnational Corridor */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            <div>
              <h2 className="text-3xl font-black mb-8 uppercase tracking-tighter">The Transnational Corridor</h2>
              <p className="text-slate-600 mb-8 text-lg leading-relaxed font-medium">
                Our mission is predicated on the principle that a healthy democracy requires a healthy citizenry and an uncorrupted flow of information.
              </p>
              <p className="text-slate-500 mb-8 leading-relaxed">
                Our work is dedicated to uncovering global patterns to ensure the sovereignty of the individual is protected against the overreach of international bureaucracies. Whether it is a public health mandate or an AI deployment, we audit the power structures behind the policies.
              </p>
              <div className="p-6 bg-slate-50 border-l-4 border-black italic font-medium text-slate-700">
                "Forensic transparency becomes the essential tool for restoration when bureaucratic drift occurs."
              </div>
            </div>
            <div className="relative group">
                <img 
                  src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072" 
                  alt="Global Map" 
                  className="grayscale rounded-none shadow-2xl transition-all duration-700 group-hover:grayscale-0 group-hover:shadow-[0_0_60px_rgba(249,115,22,0.2)]" 
                />
                <div className="absolute -bottom-6 -left-6 p-8 bg-black text-white text-[10px] font-bold uppercase tracking-[0.4em]">
                    UDHR Article 19 Compliant
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* Legal Safe Harbor */}
      <section className="py-32 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h2 className="text-4xl font-black mb-10 tracking-tighter uppercase">Legal Safe Harbor</h2>
            <p className="text-xl text-slate-400 leading-relaxed mb-10">
              Our framework is anchored in the U.S. First Amendment, providing a powerful shield for international reporting. 
            </p>
            <p className="text-slate-500 leading-relaxed mb-12">
              We align with the Universal Declaration of Human Rights, Article 19, enshrining the right to seek and impart information regardless of frontiers. By centralizing operations within jurisdictions that respect robust privacy and free speech laws, we protect our contributors and the integrity of the data.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="p-8 border border-slate-800">
                    <h4 className="font-black uppercase tracking-widest text-sm mb-4">First Amendment</h4>
                    <p className="text-xs text-slate-500 leading-relaxed">Leveraging U.S. constitutional protections to ensure investigations cannot be silenced by foreign litigation.</p>
                </div>
                <div className="p-8 border border-slate-800">
                    <h4 className="font-black uppercase tracking-widest text-sm mb-4">UDHR Article 19</h4>
                    <p className="text-xs text-slate-500 leading-relaxed">Defending the universal human right to receive and impart information across all borders.</p>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
